/* assets/variant-picker.js — stable updates, no flicker, small pulse highlight */
(function(){
  const picker = document.querySelector('[data-custom-variant-picker]');
  if(!picker) return;

  const productJSON = picker.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
  if(!productJSON) return;

  const product  = JSON.parse(productJSON.textContent || '{}');
  const variants = product.variants || [];

  const norm = (s) => (s ?? '').toString().trim().toLowerCase();

  // Cache last variant to avoid repeated updates/flicker
  let lastVariantId = null;

  function forms(){
    const out = [
      ...document.querySelectorAll('form[action*="/cart/add"]'),
      ...document.querySelectorAll('product-form form')
    ];
    return Array.from(new Set(out));
  }

  function group(kind){
    return picker.querySelector(`.variant-options[data-kind="${kind}"]`);
  }
  function groupIdx(kind){
    const el = group(kind);
    return el ? parseInt(el.getAttribute('data-option-group'), 10) : null;
  }

  function getSelected(){
    const groups = [...picker.querySelectorAll('[data-option-group]')];
    return groups.map(g =>
      g.querySelector('.option-btn.is-selected')?.getAttribute('data-value') ||
      g.querySelector('[data-value]')?.getAttribute('data-value') || ''
    );
  }

  function findVariantByOptions(sel){
    return variants.find(v => {
      const vo = v.options || [];
      if (vo.length !== sel.length) return false;
      for (let i=0;i<vo.length;i++){
        if (norm(vo[i]) !== norm(sel[i])) return false;
      }
      return true;
    });
  }

  // Color selectable if it has any size in stock; size selectable only if exact combo is in stock
  function colorHasAnyStock(colorVal){
    const c = groupIdx('color'); if (c == null) return true;
    return variants.some(v => norm(v.options[c]) === norm(colorVal) && v.available);
  }
  function sizeInStock(colorVal, sizeVal){
    const c = groupIdx('color'), s = groupIdx('size');
    if (c == null || s == null) return true;
    return variants.some(v => v.available && norm(v.options[c])===norm(colorVal) && norm(v.options[s])===norm(sizeVal));
  }

  function updateForms(variant){
    if (!variant || variant.id === lastVariantId) return; // nothing changed

    lastVariantId = variant.id;

    forms().forEach(f => {
      const idInput = f.querySelector('input[name="id"]');
      if (idInput){
        idInput.value = String(variant.id);
        idInput.dispatchEvent(new Event('change', { bubbles:true }));
      }
      const pf = f.closest('product-form');
      if (pf) pf.dataset.variantId = String(variant.id);
    });

    // Update URL only if changed
    if (history.replaceState){
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    // Notify once
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
  }

  function paintSelected(sel){
    [...picker.querySelectorAll('[data-option-group]')].forEach((g, idx) => {
      const want = sel[idx];
      g.querySelectorAll('[data-value]').forEach(btn => {
        const match = norm(btn.getAttribute('data-value')) === norm(want);
        btn.classList.toggle('is-selected', match);
        const input = btn.querySelector('.option-input');
        if (input) input.checked = match;
      });
    });
  }

  function paintAvailability(sel){
    const c = groupIdx('color'), s = groupIdx('size');

    const colorGroup = group('color');
    if (colorGroup && c != null){
      colorGroup.querySelectorAll('[data-value]').forEach(btn => {
        const cv = btn.getAttribute('data-value') || '';
        const ok = colorHasAnyStock(cv);
        btn.classList.toggle('is-oos', !ok);
        btn.classList.toggle('is-disabled', !ok);
        btn.setAttribute('aria-disabled', String(!ok));
        if (!ok) btn.setAttribute('tabindex','-1'); else btn.removeAttribute('tabindex');
      });
    }

    const sizeGroup = group('size');
    if (sizeGroup && c != null && s != null){
      const currentColor = sel[c] || '';
      sizeGroup.querySelectorAll('[data-value]').forEach(btn => {
        const sv = btn.getAttribute('data-value') || '';
        const ok = sizeInStock(currentColor, sv);
        btn.classList.toggle('is-oos', !ok);
        btn.classList.toggle('is-disabled', !ok);
        btn.setAttribute('aria-disabled', String(!ok));
        if (!ok) btn.setAttribute('tabindex','-1'); else btn.removeAttribute('tabindex');
      });
    }
  }

  function coerceToAvailable(sel){
    const c = groupIdx('color'), s = groupIdx('size');
    if (c == null) return sel;

    // If color has no stock at any size, set first stocked color
    if (!colorHasAnyStock(sel[c])){
      const firstColor = variants.find(v => v.available)?.options[c];
      if (firstColor) sel[c] = firstColor;
    }
    // If size for that color is OOS, set first in-stock size for that color
    if (s != null && !sizeInStock(sel[c], sel[s])){
      const firstSize = variants
        .filter(v => v.available && norm(v.options[c])===norm(sel[c]))
        .map(v => v.options[s])[0];
      if (firstSize) sel[s] = firstSize;
    }
    return sel;
  }

  function refresh(){
    let sel = getSelected();
    sel = coerceToAvailable(sel);
    paintSelected(sel);
    paintAvailability(sel);

    const variant = findVariantByOptions(sel);
    if (variant) updateForms(variant);
  }

  function onClick(e){
    const btn = e.target.closest('[data-value]');
    if(!btn || !picker.contains(btn)) return;
    if (btn.classList.contains('is-disabled') || btn.classList.contains('is-oos')) return;

    const group = btn.closest('[data-option-group]');
    if (!group) return;

    group.querySelectorAll('.option-btn').forEach(b => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');

    const input = btn.querySelector('.option-input');
    if (input){ input.checked = true; input.dispatchEvent(new Event('change', { bubbles:true })); }

    refresh();
  }

  // Initialize to first available variant, once
  (function init(){
    const v = variants.find(v => v.available) || variants[0];
    if (!v) return;
    const groups = [...picker.querySelectorAll('[data-option-group]')];
    groups.forEach((g, idx) => {
      const want = v.options[idx];
      g.querySelectorAll('.option-btn').forEach(b => {
        const vv = b.getAttribute('data-value') || '';
        b.classList.toggle('is-selected', norm(vv)===norm(want));
        const input = b.querySelector('.option-input'); if (input) input.checked = norm(vv)===norm(want);
      });
    });
    lastVariantId = v.id; // seed so first refresh updates cleanly
  })();

  picker.addEventListener('click', onClick);
  refresh();
})();
